/**
 * SessionStatusBadge — badge de estado para sesiones de relevamiento
 *
 * @module survey/components
 */

import type { SurveySessionStatus } from '../types/survey.types';

interface Props {
  status: SurveySessionStatus;
}

const STATUS_CONFIG: Record<SurveySessionStatus, { label: string; className: string }> = {
  draft: { label: 'Borrador', className: 'ssb ssb--draft' },
  uploading: { label: 'Cargando archivos', className: 'ssb ssb--uploading' },
  processing: { label: 'Procesando', className: 'ssb ssb--processing' },
  processed: { label: 'Procesado', className: 'ssb ssb--processed' },
  failed: { label: 'Error', className: 'ssb ssb--failed' },
  archived: { label: 'Archivado', className: 'ssb ssb--archived' },
};

export function SessionStatusBadge({ status }: Props): JSX.Element {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.draft;
  return <span className={config.className}>{config.label}</span>;
}
